function nullIfUndefined(variable) {
    return variable === undefined ? null : variable;
}

function trueIfUndefined(variable) {
    return variable === undefined ? true : variable;
}

function falseIfUndefined(variable) {
    return variable === undefined ? false : variable;
}

function zeroIfUndefined(variable) {
    return variable === undefined ? 0 : variable;
}
